import TableRow from "@mui/material/TableRow";
import { Box, Chip } from "@mui/material";
import { dateFormat, formatMoney } from "../../../common/utils";
import PayPal from "../images/paypal.png";
import Venmo from "../images/venmo.png";
import { LiParagraph, LiTableCell } from "../components/pieces";
import { ClickableText } from "../components/Typography";
import type { Payout, AppContext } from "../../../types";

interface PayoutTableRowProps {
    payout: Payout;
    context: AppContext;
    onClick: (payout: Payout) => void;
}

const PayoutTableRow = ({ payout, context, onClick }: PayoutTableRowProps) => {
    const images: Record<string, string> = {
        paypal: PayPal,
        venmo: Venmo,
    };

    const chipMap: Record<string, "success" | "error" | "info"> = {
        Sent: `success`,
        Returned: `error`,
        Canceled: `error`,
        Requested: `info`,
    };

    const brandNames: Record<string, string> = {
        paypal: `PayPal`,
        venmo: `Venmo`,
    };

    return (
        <TableRow sx={{ border: `none`, borderTop: `1px solid #E1E1E1` }}>
            <LiTableCell sx={{ textAlign: `left`, padding: `16px 16px 16px 28px`, maxWidth: 80 }}>
                <LiParagraph>
                    {dateFormat(payout[`Payout Date`] ? payout[`Payout Date`] : context.nextFifteen)}
                </LiParagraph>
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `left`, padding: `16px 0 16px 28px`, width: `35px` }}>
                <Box
                    sx={{ maxHeight: 35, height: `auto`, maxWidth: 35, width: `auto`, verticalAlign: `middle` }}
                    component="img"
                    src={images[payout[`Payout Type`]]}
                />
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `left`, padding: `16px 16px 16px 0 ` }}>
                <Box sx={{ marginLeft: `10px`, display: `inline`, verticalAlign: `middle` }}>
                    {brandNames[payout[`Payout Type`]]}
                </Box>
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `right`, padding: `16px 28px 16px 16px` }}>
                <LiParagraph>{formatMoney(payout[`Payout Amount`])}</LiParagraph>
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `center`, padding: `24px 28px 24px 24px`, width: 80 }}>
                <Box
                    sx={{
                        display: `flex`,
                        alignItems: `center`,
                        justifyContent: `center`,
                    }}
                >
                    <Chip
                        sx={{ padding: `1px 8px 0` }}
                        size="small"
                        label={payout[`Payout Status`]}
                        color={chipMap[payout[`Payout Status`]]}
                    />
                </Box>
            </LiTableCell>
            {context?.adminConfig!.mall!.CORE_SETTINGS![`Payout Method`] === `Request` && (
                <LiTableCell sx={{ maxWidth: `65px` }}>
                    <LiParagraph>
                        {payout[`Payout Status`] === `Requested` && payout.cancelId && (
                            <ClickableText onClick={() => onClick(payout)}>Cancel</ClickableText>
                        )}
                    </LiParagraph>
                </LiTableCell>
            )}
        </TableRow>
    );
};

export default PayoutTableRow;
